
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/estate-agents",
      function () {
        return require("private-next-pages/partners/estate-agents.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/estate-agents"])
      });
    }
  